// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/turn-forces.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/turn-forces/turn-forces.js';

mount([g0]);
